<template>
  <svg viewBox="2 2 20 20" fill="currentColor" width="16" height="16" aria-hidden="true">
    <path
      v-for="path in paths"
      :key="path.d"
      :d="path.d"
      :fill-rule="path.evenodd ? 'evenodd' : undefined"
    />
  </svg>
</template>

<script>
// One shared action-icon set (see icons.js). The 16px attribute size is a
// fallback — contexts that size their icons (ds-button, ds-icon-button,
// ds-info-button) override it in CSS.

import { ICON_PATHS } from './icons'

export default {
  name: 'DsIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => value in ICON_PATHS,
    },
  },
  computed: {
    paths() {
      return ICON_PATHS[this.name]
    },
  },
}
</script>
